import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.flat-map.js";
import "core-js/modules/es.iterator.map.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "mt-4 border-t border-slate-100 pt-4"
};
const _hoisted_2 = ["disabled"];
import { reactive, ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { createFolder, updateFolder } from '@/api/assets';
import AssetFolderAclEditor from './AssetFolderAclEditor.vue';
export default {
  __name: 'AssetFolderDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'create'
    },
    folder: {
      type: Object,
      default: null
    },
    parentId: {
      type: [Number, String],
      default: 0
    }
  },
  emits: ['update:visible', 'success'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const form = reactive({
      name: ''
    });
    const submitting = ref(false);
    const visibilityType = ref('INHERIT');
    const aclItems = ref([]);
    watch(() => props.visible, val => {
      if (val && props.mode === 'edit' && props.folder) {
        form.name = props.folder.name || '';
      } else if (val) {
        form.name = '';
        visibilityType.value = 'INHERIT';
        aclItems.value = [];
      }
    });
    function normalizeSubjectIds(item) {
      if (item.subjectType === 'ALL_AUTHENTICATED') return 0;
      const value = item.subjectValue;
      const values = Array.isArray(value) ? value : [value];
      return values.map(subject => {
        if (subject && typeof subject === 'object') return Number(subject.id) || 0;
        return Number(subject) || 0;
      }).filter(Boolean);
    }
    function expandAclItems() {
      return aclItems.value.flatMap(item => {
        if (item.subjectType === 'ALL_AUTHENTICATED') {
          return [{
            subjectType: item.subjectType,
            subjectId: normalizeSubjectIds(item),
            permissionLevel: item.permissionLevel
          }];
        }
        return normalizeSubjectIds(item).map(subjectId => ({
          subjectType: item.subjectType,
          subjectId,
          permissionLevel: item.permissionLevel
        }));
      });
    }
    async function handleSubmit() {
      submitting.value = true;
      try {
        if (props.mode === 'create') {
          await createFolder({
            parentId: props.parentId,
            name: form.name,
            visibilityType: visibilityType.value,
            aclList: visibilityType.value === 'CUSTOM' ? expandAclItems() : []
          });
        } else {
          await updateFolder(props.folder.id, {
            name: form.name,
            lockVersion: props.folder.lockVersion
          });
        }
        ElMessage.success(props.mode === 'create' ? '文件夹已创建' : '文件夹已更新');
        emit('success');
        emit('update:visible', false);
      } catch {
        // handled by interceptor
      } finally {
        submitting.value = false;
      }
    }
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        "model-value": __props.visible,
        title: __props.mode === 'create' ? '新建文件夹' : '编辑文件夹',
        width: __props.mode === 'create' ? '760px' : '420px',
        style: {
          "max-width": "92vw"
        },
        "close-on-click-modal": false,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.$emit('update:visible', $event))
      }, {
        footer: _withCtx(() => [_createElementVNode("button", {
          type: "button",
          class: "btn-secondary",
          onClick: _cache[3] || (_cache[3] = $event => _ctx.$emit('update:visible', false))
        }, "取消"), _createElementVNode("button", {
          type: "button",
          class: "btn-primary",
          disabled: !form.name || submitting.value,
          onClick: handleSubmit
        }, _toDisplayString(submitting.value ? '提交中...' : __props.mode === 'create' ? '创建' : '保存'), 9, _hoisted_2)]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: form,
          "label-width": "80px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "文件夹名称",
            required: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.name = $event),
              placeholder: "输入文件夹名称",
              maxlength: "100"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"]), __props.mode === 'create' ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(AssetFolderAclEditor, {
          "visibility-type": visibilityType.value,
          "onUpdate:visibilityType": _cache[1] || (_cache[1] = $event => visibilityType.value = $event),
          "acl-items": aclItems.value,
          "onUpdate:aclItems": _cache[2] || (_cache[2] = $event => aclItems.value = $event)
        }, null, 8, ["visibility-type", "acl-items"])])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["model-value", "title", "width"]);
    };
  }
};